import { Pipe, PipeTransform } from '@angular/core';
import { SlicePipe } from '@angular/common';

@Pipe({
    name: 'pureslice',
    pure: true,
    standalone: false
})
/**
 * A Pure pipe alternative to Angular's built in SlicePipe
 */
export class PureSlicePipe implements PipeTransform {
  static slice = new SlicePipe();
  transform(data, start: number, end?: number) {
    return PureSlicePipe.slice.transform(data, start, end);
  }
}
